import React, { useState } from 'react';
import './Home.css';
import '../styles/font.css';


export default function Home() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);


  
  // Toggle the menu visibility
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);}
  return (
  <div className='Home'>

  <div className="home" id="home">
      <div className="left">
        <div className="first">
          <img 
          src="\assets\Component 4.png"
          alt="Background shape"
          />
        </div>
      </div>
      <div className="right" dir="rtl">
        <h1 className="title">الموقع الرسمي للدكتور مصطفى الخشت</h1>
        <p className="description">
          هو أحد أهم خبراء الحقن المجهري وعلاج أسباب تأخر الحمل للزوجين.. سواء كانت أسباب بسيطة للوصول لحمل طبيعي أو استخدام الوسائل
          المساعدة للوصول للحمل وهو الحقن المجهري الذي يصل نسب نجاحه 70% بفضل الله
        </p>
        <p className="contact">عضوالجمعيه الامريكيه للخصوبه والعقم</p>
        <p className="contact"> عضوالجمعيه الاوربيه للخصوبه والعقم</p>
      </div>
    </div>
  </div>
  );
}